// 數據篩選工具函數

export interface FilterableData {
  data: Array<{ org_name: string; [key: string]: any }>;
  [key: string]: any;
}

/**
 * 根據組織名稱篩選數據
 * @param data 原始數據
 * @param selectedOrgs 選中的組織名稱數組
 * @returns 篩選後的數據
 */
export const filterDataByOrgs = (data: FilterableData | null, selectedOrgs: string[]): FilterableData | null => {
  if (!data || !data.data || !Array.isArray(data.data)) {
    return data;
  }

  // 如果沒有選擇任何組織，返回原始數據
  if (selectedOrgs.length === 0) {
    return data;
  }

  // 檢查是否是資源使用情況的特殊格式 [orgName, { total, resources }]
  const isResourceUsageFormat = data.data.length > 0 && 
    Array.isArray(data.data[0]) && 
    data.data[0].length === 2 &&
    typeof data.data[0][0] === 'string';

  if (isResourceUsageFormat) {
    // 處理資源使用情況的特殊格式
    const filteredData = data.data.filter((item: any) => 
      Array.isArray(item) && selectedOrgs.includes(item[0])
    );

    return {
      ...data,
      data: filteredData
    };
  }

  // 標準格式的篩選
  const filteredData = data.data.filter(item => 
    selectedOrgs.includes(item.org_name)
  );

  return {
    ...data,
    data: filteredData
  };
};

/**
 * 從數據中提取所有可用的組織名稱
 * @param data 數據
 * @returns 組織名稱數組
 */
export const extractOrgsFromData = (data: FilterableData | null): string[] => {
  if (!data || !data.data || !Array.isArray(data.data)) {
    return [];
  }

  // 檢查是否是資源使用情況的特殊格式
  const isResourceUsageFormat = data.data.length > 0 && 
    Array.isArray(data.data[0]) && 
    data.data[0].length === 2 &&
    typeof data.data[0][0] === 'string';

  if (isResourceUsageFormat) {
    // 從資源使用情況格式中提取組織名稱
    const orgSet = new Set<string>(
      data.data
        .map((item: any) => Array.isArray(item) ? item[0] : null)
        .filter(org => org && org.trim() !== '')
    );
    return Array.from(orgSet).sort();
  }

  // 標準格式的組織名稱提取
  const orgSet = new Set<string>(
    data.data
      .map(item => item.org_name as string)
      .filter(org => org && org.trim() !== '')
  );

  return Array.from(orgSet).sort();
}; 